import React from "react";
import { stepStyles } from "./formStyles";

export const Submit = () => {
  return (
    <div className={stepStyles.page}>
      <div className={stepStyles.content}>
        <div className="mx-auto flex w-full max-w-3xl flex-col items-center rounded-4xl border border-brand-border bg-white/92 px-6 py-12 text-center shadow-panel backdrop-blur-sm md:px-12 md:py-16">
          <h1 className={stepStyles.title}>Thank you</h1>
          <p className="mt-6 max-w-2xl text-lg font-medium text-gray-satan md:text-xl">
            Your request has been submitted. A member of the team will be in touch soon.
          </p>
        </div>
      </div>
    </div>
  );
};
